<mat-form-field class="is-comfortably-readable">
    @if (autoPopulated()) {
        <mat-icon
            class="auto-populate-icon"
            matPrefix
            svgIcon="auto-populate"
            [matTooltip]="'research.auto.populate.tooltip' | customTranslate"
        ></mat-icon>
    }
    @if (label(); as label) {
        <mat-label>{{ label }}</mat-label>
    }
    <mat-select [placeholder]="placeholder()" [formControl]="dataSvc.status">
        @for (option of statusOptions(); track option) {
            <mat-option [value]="option">
                {{ 'research.publication.status.' + option | customTranslate }}
            </mat-option>
        }
    </mat-select>
    @if (hint(); as hint) {
        <mat-hint>{{ hint }}</mat-hint>
    }
</mat-form-field>
